export const getClaimerInitials = (name: string): string => {
  const tokens = name.trim().split(/\s+/).filter(Boolean);

  if (tokens.length === 0) {
    return '';
  }

  if (tokens.length === 1) {
    return tokens[0].charAt(0).toUpperCase();
  }

  const first = tokens[0].charAt(0).toUpperCase();
  const last = tokens[tokens.length - 1].charAt(0).toUpperCase();

  return `${first}${last}`;
};
